import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

export default function Logo() {
  return (
    <S.Logo
      to="/"
      onClick={() =>
        document.querySelector('#root').scrollTo({ top: 0, left: 0 })
      }
    >
      <svg
        version="1.1"
        id="Ebene_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 794.75 134.89"
      >
        <title>wertfrei_logo_grau</title>
        <path
          d="M167.86,39.59l-34.71,95.74H106.46L84.93,75.89,62.68,135.33H36L1.47,39.59H27.62l22.61,64.77L73.72,39.59H97.21L120,104.36,143.3,39.59Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M271.6,95.29H199.18a22.52,22.52,0,0,0,9.25,14.06q7.29,5.16,18.15,5.16a36.64,36.64,0,0,0,13.26-2.23,32,32,0,0,0,10.76-7l14.78,16q-13.53,15.48-39.51,15.48-16.2,0-28.65-6.31A46.31,46.31,0,0,1,178,112.91a48.3,48.3,0,0,1-6.76-25.45,48.91,48.91,0,0,1,6.67-25.36,46.78,46.78,0,0,1,18.33-17.62,56.83,56.83,0,0,1,51.52-.27,44.19,44.19,0,0,1,17.88,17.36q6.5,11.29,6.5,26.24Q272.14,88.35,271.6,95.29Zm-65-30.79q-6.41,5.34-7.83,14.6H246a23,23,0,0,0-7.83-14.51,23.39,23.39,0,0,0-15.66-5.43Q213.05,59.16,206.65,64.5Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M328.82,41.72a49.89,49.89,0,0,1,19.48-3.55V63.79q-4.62-.36-6.23-.36-11.93,0-18.68,6.68t-6.76,20v45.2H288.87V39.59h26.51V52.22A31,31,0,0,1,328.82,41.72Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M434.43,130.7a28.36,28.36,0,0,1-10.05,4.54,50.82,50.82,0,0,1-12.55,1.51q-17.08,0-26.42-8.72t-9.35-25.62V63.08H361.29V41.72h14.77V18.41h27.77V41.72h23.84V63.08H403.83v39q0,6.06,3.11,9.34t8.81,3.3A17.86,17.86,0,0,0,427,111.13Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M485.86,41.72h24.56V63.08H486.57v72.25H458.81V63.08H444V41.72h14.77V37.45q0-16.37,9.7-26t27.32-9.61A50.87,50.87,0,0,1,507.66,3.2,28.73,28.73,0,0,1,517,7l-7.29,20.11a19,19,0,0,0-11.21-3.38q-12.64,0-12.64,13.88Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M567.63,41.72a49.94,49.94,0,0,1,19.49-3.55V63.79c-3.09-.24-5.16-.36-6.23-.36q-11.92,0-18.68,6.68t-6.77,20v45.2H527.68V39.59H554.2V52.22A31,31,0,0,1,567.63,41.72Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M695.85,95.29H623.42a22.56,22.56,0,0,0,9.25,14.06q7.3,5.16,18.16,5.16a36.55,36.55,0,0,0,13.25-2.23,31.92,31.92,0,0,0,10.77-7l14.77,16q-13.53,15.48-39.51,15.48-16.18,0-28.65-6.31a46.37,46.37,0,0,1-19.22-17.53,48.3,48.3,0,0,1-6.76-25.45,48.92,48.92,0,0,1,6.68-25.36,46.69,46.69,0,0,1,18.32-17.62A56.83,56.83,0,0,1,672,44.21a44.21,44.21,0,0,1,17.89,17.36q6.5,11.29,6.49,26.24Q696.38,88.35,695.85,95.29Zm-65-30.79q-6.4,5.34-7.82,14.6h47.15a23,23,0,0,0-7.83-14.51,23.39,23.39,0,0,0-15.66-5.43A23.92,23.92,0,0,0,630.89,64.5Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M714.89,39.59h27.76v95.74H714.89Z"
          transform="translate(-1.47 -1.86)"
        />
        <path
          d="M766.67,131.77a16.9,16.9,0,0,1-5-12.46,16.23,16.23,0,0,1,5-12.36,18.33,18.33,0,0,1,24.56,0,16.23,16.23,0,0,1,5,12.36,16.9,16.9,0,0,1-5,12.46,17.63,17.63,0,0,1-24.56,0Z"
          transform="translate(-1.47 -1.86)"
        />
      </svg>
    </S.Logo>
  )
}

const S = {
  Logo: styled(Link)`
    position: fixed;
    width: 11rem;
    left: 6.5rem;
    top: 2.8rem;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 9000;

    svg {
      enable-background: new 0 0 841.89 595.28;

      path {
        fill: #090a0a;
      }
    }
  `,
}
